import MapsController from "./maps_controller"

export default class extends MapsController {
  static targets = [...MapsController.targets, "status", "selection"]

  connect() {
    this.handleMapError = () => this.mapUnavailable()
    window.addEventListener("google-maps:error", this.handleMapError)
    this.loadTimeout = setTimeout(() => { if (!this.mapInitialized) this.mapUnavailable() }, 12000)
    super.connect()
    if (window.googleMapsAuthFailed) this.mapUnavailable()
    this.selectionChanged()
  }

  disconnect() {
    clearTimeout(this.loadTimeout)
    window.removeEventListener("google-maps:error", this.handleMapError)
    super.disconnect()
  }

  initializeMap() {
    if (!this.markersValue.length || window.googleMapsAuthFailed) return
    try {
      super.initializeMap()
      if (!this.mapInitialized) return
      clearTimeout(this.loadTimeout)
      this.mapTarget.hidden = false
      this.selectionChanged()
    } catch (_error) {
      this.mapInitialized = false
      this.mapUnavailable()
    }
  }

  renderMarkers() {
    super.renderMarkers()
    this.shipmentMarkers = new Map()
    this.markers().forEach((marker, index) => {
      const data = this.markersValue[index]
      data.shipments.forEach(shipment => this.shipmentMarkers.set(String(shipment.shipment_id), { marker, data }))
    })
  }

  // Fit once when the map becomes visible, then preserve the user's pan.
  afterResize() {
    if (!this.fittedVisible) this.fitLocations()
  }

  fitLocations() {
    if (!this._map || this.mapTarget.hidden || this.mapTarget.clientWidth === 0) return
    this.fittedVisible = true
    const bounds = new google.maps.LatLngBounds()
    this.markers().forEach(marker => bounds.extend(marker.getPosition()))
    if (this.markers().length === 1) {
      this.map().setCenter(bounds.getCenter())
      this.map().setZoom(15)
    } else if (this.markers().length) this.map().fitBounds(bounds, 48)
  }

  addText(parent, text, className) {
    const element = document.createElement("div")
    element.className = className
    element.textContent = text
    parent.append(element)
  }

  buildMarkerIcon(color = "#6c757d", selected = false) {
    const safeColor = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(color) ? color : "#6c757d"
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="46" viewBox="0 0 36 46"><path fill="${safeColor}" stroke="${selected ? "#111827" : "#fff"}" stroke-width="${selected ? 4 : 2}" d="M18 3C9 3 3 9 3 18c0 10 15 25 15 25s15-15 15-25C33 9 27 3 18 3Z"/><circle cx="18" cy="18" r="6" fill="#fff"/>${selected ? '<path d="m14 18 3 3 6-7" fill="none" stroke="#111827" stroke-width="2"/>' : ""}</svg>`
    return { anchor: new google.maps.Point(18, 44), scaledSize: new google.maps.Size(36, 46), url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}` }
  }
}
